import './index.scss'
import return_anim_item from "./../../module/animation";

return_anim_item('.footer__block', 'anim_right', 0);
return_anim_item('.footer_copyright', 'anim_bottom', 200);

return_anim_item('.footer_content_logo', 'anim_bottom', 100);
return_anim_item('.footer_content_nav', 'anim_bottom', 200);
